import { useParams, useNavigate,Link ,useLocation} from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import BankView from './BankView';
import withPermission from '../../../utils/withPermission';
import { useAuth } from '../../../context/AuthContext';

import TransactionList from './TransactionList';
import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsChevronLeft } from "react-icons/bs"; 
import BankModal from './BankModal';
const BankDetail = () => {
    const { id } = useParams(); // Get bank ID from the URL
    const navigate = useNavigate();
    const location = useLocation();
    
    const [bankDetails, setBankDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('transactionList');
    const { permissions } = useAuth();
    const WithTenanatPermission = withPermission(({ children }) => children, ['tenant-list']);
    const didFetchRef = useRef(false); // Use ref to track whether the API has been called
    const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
    const WithDocumentPermission = withPermission(({ children }) => children, ['document-list']);
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") ||"transactionList"
    const [selectedBank, setSelectedBank] = useState(null);
        const [showModal, setShowModal] = useState(false);
        const [banks, setBanks] = useState([]);
        const [countries, setCountries] = useState([]);

    const fetchBankDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/bank-accounts/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setBankDetails(response.data); // Set the fetched data to state
        } catch (error) {
            console.error('Error fetching bank details:', error);
        }
    };
    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
    
            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: { Authorization: `Bearer ${token}` ,
                    'Tenant-Origin': origin,
            
            },
                skipLoader: true,
            });
    
            let countryList = response.data.Data;
    
            // Ensure country with ID 231 (AED) appears first
            // countryList = countryList.sort((a, b) => (a.id === 231 ? -1 : b.id === 231 ? 1 : 0));
    
            setCountries(countryList);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const editBank = async (bankId, updatedData) => {
       
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/bank-accounts/${bankId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const updatedBank = response.data?.account;

            if (updatedBank) {
                setBankDetails((prevLead) => ({
                    ...prevLead,
                    ...updatedBank, // Merge updated data
                }));
                setBanks((prevBanks) =>
                    prevBanks.map((bank) =>
                        bank.id === updatedBank.id ? updatedBank : bank
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            setShowModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error updating bank:', error);
            }
        }
    };

    useEffect(() => {
        if (!didFetchRef.current) {
            fetchBankDetails(); // Only fetch data if it hasn't been done before
            didFetchRef.current = true; // Mark that data has been fetched
        }
    }, [id]); // This will run only when `id` changes

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const activeTabParam = queryParams.get("activeTab") || "transactionList"; // Default to 'tenantInfo'
        setActiveTab(activeTabParam); // Set the active tab based on URL parameter
      }, [location.search]);
    const handleBackClick = () => {
        navigate(-1);
    };

    // Handle tab click to change active tab
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        navigate(`${location.pathname}?activeTab=${tab}`);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0 d-flex align-items-center first-title">
                                    <BsChevronLeft
                                        className='back-button1'
                                        onClick={() => navigate(-1)}
                                    />
                                    <span>Accounts</span>
                                </h4>                                
                                <div className="page-title-right br-font">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><Link to={`/bank/details/${id}?activeTab=bankInfo`}>
                                            {bankDetails?.name || " Bank Details"}
                                        </Link></li>
                                        <li className="breadcrumb-item active">Details</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-6 max-w-7xl mx-auto">
                    <>
                            <Card className="mb-4 shadow-lg rounded-3 p-2 border-0 card-bg ">
                                {/* Header Section with Name and Edit Icon */}
                                <div className="d-flex justify-content-between align-items-center">
                                    <Card.Title className="fw-bold font-size-14 text-primary">{bankDetails?.name}</Card.Title>
                                    <BiPencil
                                        className="text-primary hover-effect2 edit-pencil"
                                        onClick={() => {
                                            setSelectedBank(bankDetails); // Store organisation details
                                            setShowModal(true); // Open modal
                                        }} />
                                </div>
                                <Card.Body className="pt-3">
                                    <div className="row">
                                        {/* Left Section */}
                                        <div className="col-md-6 ">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Account Type:</strong></span>
                                                <span className=" text-muted card-value">{bankDetails?.type || '-'}</span>
                                            </div>
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Branch Name:</strong></span>
                                                <span className=" text-muted card-value">{bankDetails?.branch_name || '-'}</span>
                                            </div>
                                        </div>

                                        {/* Right Section */}
                                        <div className="col-md-4 ">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Opening Balance:</strong></span>
                                                <span className="fw-semibold text-primary card-value">{bankDetails?.opening_balance || ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            {showModal && (
                                <BankModal
                                    showModal={showModal}
                                    handleClose={() => setShowModal(false)}
                                    bankData={selectedBank} // Pass data here
                                    editBank={editBank}
                                    banks={banks}
                                    bankId={id}
                                    countries={countries}
                                    fetchCountries={fetchCountries}
                                   
                                />
                            )}


                        </>
                    <div className="row">
                    <div className="col-xl-12 col-lg-8">
                                <div className="card">
                                    {/* Nav tabs */}
                                    <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
                                    <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'transactionList' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('transactionList')}
                                                role="tab"
                                            >
                                                TransactionList
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'bankDetails' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('bankDetails')}
                                                role="tab"
                                            >
                                                Bank Details
                                            </a>
                                        </li>
                                        
                                    </ul>
                                    <div className="tab-content p-4">
                                       
                                        {activeTab === "bankDetails" && bankDetails && (
                                            <div className="tab-pane active" id="instacne-list" role="tabpanel">
                                                <div className="p-3">
                                                <BankView bankData={bankDetails} setBankDetails={setBankDetails}/>
                                                </div>
                                            </div>
                                        )}
                                         {activeTab === "transactionList" && bankDetails && (
                                            <div className="tab-pane active" id="instacne-list" role="tabpanel">
                                                <div className="p-3">
                                                <TransactionList accountId={bankDetails?.id} fetchBankDetails={fetchBankDetails} setBankDetails={setBankDetails}/>
                                                </div>
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                    </div>
                      
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BankDetail;
